
<mat-sidenav-container>
  <mat-sidenav #sidenav  mode="{{isMobile ? 'over' : 'side'}}"  opened="{{!isMobile}}" [disableClose]="!isMobile">
    <a id="mainLogo">
      <img src="{{sidebarLogo}}" />
    </a>
    <mat-nav-list *ngIf="!acordionsEnabled">
      <mat-divider></mat-divider>
      <a mat-list-item  *ngFor="let route of navigationRoutes" [routerLink]="route.path" routerLinkActive="active-link" (click)="routeBtnClick(route)">
        <div></div>
        <mat-icon class="nav-icon">{{route.icon}}</mat-icon>
        <span>
          <mat-icon>arrow_forward_ios</mat-icon>{{ route.name }}
        </span>
        <mat-divider></mat-divider>
      </a>
    </mat-nav-list>

    <mat-accordion *ngIf="acordionsEnabled">
      <div *ngFor="let navTree of navigationData; let navDataIndex = index;" >
        <mat-divider></mat-divider>
        <mat-expansion-panel >
          <mat-expansion-panel-header>
            <span></span>
            <mat-panel-title>
              {{navTree.title}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-divider></mat-divider>
            <a mat-list-item  *ngFor="let route of navTree.routes" [routerLink]="route.path"  routerLinkActive="active-link" (click)="routeBtnClick(route, navDataIndex)">
              <div></div>
              <mat-icon class="nav-icon">{{route.icon}}</mat-icon>
              <span>
                <mat-icon>arrow_forward_ios</mat-icon>{{ route.name }}
              </span>
              <mat-divider></mat-divider>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>
      </div>
      <mat-divider></mat-divider>
    </mat-accordion>
    
  </mat-sidenav>

  <mat-sidenav-content>

    <mat-toolbar color="primary" *ngIf="!isMobile">
      
      <mat-toolbar-row>
        <a>
          <img src="{{toolbarLogo}}" />
        </a>
        <span class="spacer"></span>
        <button mat-mini-fab color="accent" [matMenuTriggerFor]="userMenu">
          <mat-icon>settings</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu" id="settingsMenu">
          <button mat-menu-item (click)="copyUserName()">
            <mat-icon>face</mat-icon>
            <span>{{ userData.name }}</span>
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-menu-item (click)="copyUserEmail()">
            <mat-icon>email</mat-icon>
            <span>{{ userData.email }}</span>
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Cerrar Sesión</span>
          </button>
        </mat-menu>
      </mat-toolbar-row>
      <mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="primary"></mat-progress-bar>
    </mat-toolbar>

    <mat-toolbar id="mobileTopBar" *ngIf="isMobile">
      <mat-toolbar-row>

        <a>
          <img class="mobileCustomerLogo" src="{{toolbarLogo}}" />
        </a>
        <span class="spacer"></span>
        <a routerLink="home">
          <img src="{{sidebarLogo}}" />
        </a>
      </mat-toolbar-row>
    </mat-toolbar>

    <div id="views-container">
      <router-outlet></router-outlet>
    </div>

    <mat-toolbar id="mobileBottomBar" *ngIf="isMobile">
      <mat-toolbar-row>
        <button mat-icon-button (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="userMenu">
          <mat-icon>settings</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu" id="settingsMenu" xPosition="after" yPosition="above">
          <button mat-menu-item (click)="copyUserName()">
            <mat-icon>face</mat-icon>
            <span>{{ userData.name }}</span>
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-menu-item (click)="copyUserEmail()">
            <mat-icon>email</mat-icon>
            <span>{{ userData.email }}</span>
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Cerrar Sesión</span>
          </button>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>

  </mat-sidenav-content>
</mat-sidenav-container>